/** Shopify CDN: Minification failed

Line 17:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 29:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 30:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 32:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 33:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 68:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 80:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 81:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 95:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 116:4 Transforming let to the configured target environment ("es5") is not supported yet
... and 4 more hidden warnings

**/
window.addEventListener("DOMContentLoaded", () => {
  const productFormId = document
    .querySelector("product-form form")
    .getAttribute("id");

  document
    .querySelector("#select-variants-id")
    .setAttribute("form", productFormId);
  document.querySelector("kaching-bundle")?.remove();

  document.querySelector('.form__width input[name="id"]')?.remove();
  document.querySelector('product-form form input[name="id"]')?.remove();
});
class variantPack extends HTMLElement {
  constructor() {
    super();
    let is_ajax = this.closest(".product-quick-add__inner") ? true : false;
    let is_collection_item = this.closest(".product-quick-add__collection");

    if (is_ajax) {
      this.formId = this.closest(".product-quick-add__inner")
        .querySelector("form")
        .getAttribute("id");
    } else if (is_collection_item) {
      this.formId = this.closest(".product-quick-add__collection")
        .querySelector("form")
        .getAttribute("id");
    } else {
      this.formId = this.closest(".product__content")
        .querySelector(".product__block form")
        .getAttribute("id");
    }

    this.closest(".pack-selector-form")
      .querySelector("#select-variants-id")
      .setAttribute("form", this.formId);
    this.pack_title = this.getAttribute("pack-title");
    this.all_packs = document.querySelectorAll("variant-pack");
    this.select_size = this.querySelector(".variant-size");
    this.input_quantity = this.querySelector(".variant-pack__quantity-input");
    this.input_quantity_minus = this.querySelector(
      ".variant-pack__quantity-minus"
    );
    this.input_quantity_plus = this.querySelector(
      ".variant-pack__quantity-plus"
    );

    this.updateQuickAddID();

    this.attachEventListeners();
  }

  attachEventListeners() {
    this.addEventListener("click", this.selectPack.bind(this));
    this.input_quantity_minus.addEventListener(
      "click",
      this.decreaseQuantity.bind(this)
    );
    this.input_quantity_plus.addEventListener(
      "click",
      this.increaseQuantity.bind(this)
    );

    this.select_size.addEventListener("change", (event) => {
      const selected_size = event.target.value;
      const variant_title = `${this.pack_title} / ${selected_size}`;

      this.closest(".pack-selector-form").querySelector(
        "#select-variants-id"
      ).value = this.select_size.value;

      if (this.classList.contains("selected")) {
        this.updateQuickAddID();
        this.updateQuantity();
      }
    });
    document.querySelector("sticky-add").dispatchEvent(new Event("reload"));
  }

  updateQuickAddID() {
    if (
      this.closest(".product-quick-add__form")?.querySelector(
        '.product__block + input[name="id"]'
      )
    ) {
      if (this.closest(".product-quick-add__collection")) {
        this.closest(".product-quick-add__collection").querySelector(
          '.product__block.product__block--buttons + input[name="id"]'
        ).value = this.closest(".pack-selector-form").querySelector(
          "#select-variants-id"
        ).value;
      } else {
        this.closest(".product-quick-add__inner").querySelector(
          '.product__block + input[name="id"]'
        ).value = this.closest(".pack-selector-form").querySelector(
          "#select-variants-id"
        ).value;
      }
    }

    let current_price = parseFloat(document.querySelector('variant-pack.selected .variant-pack__price-amount').innerHTML.replace(',', '.')) * 100;
    setTimeout(function() {
      
    document.getElementsByTagName("klarna-placement")[0].setAttribute("data-purchase-amount", current_price);
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
    window.Klarna?.OnsiteMessaging?.refresh()
    }, 200);
  }

  selectPack() {
    this.all_packs.forEach((pack) => {
      pack.classList.remove("selected");
    });
    this.classList.add("selected");
    this.closest(".pack-selector-form").querySelector(
      "#select-variants-id"
    ).value = this.select_size.value;
    this.updateQuantity();
    this.updateQuickAddID();
  }

  decreaseQuantity() {
    if (parseInt(this.input_quantity.innerHTML) > 1) {
      this.input_quantity.innerHTML =
        parseInt(this.input_quantity.innerHTML) - 1;
    } else {
      this.input_quantity_minus.classList.add("disabled");
    }
    this.updateQuantity();
  }

  increaseQuantity() {
    this.input_quantity.innerHTML = parseInt(this.input_quantity.innerHTML) + 1;
    this.input_quantity_minus.classList.remove("disabled");
    this.updateQuantity();
  }

  updateQuantity() {
    if (
      this.closest(".product-quick-add__form")?.querySelector(
        '.product__block input[name="quantity"]'
      )
    ) {
      this.closest(".product-quick-add__form").querySelector(
        '.product__block input[name="quantity"]'
      ).value = parseInt(this.input_quantity.innerHTML);
    } else if (this.closest(".product-quick-add__collection")) {
      this.closest(".product-quick-add__collection").querySelector(
        'input[name="quantity"]'
      ).value = parseInt(this.input_quantity.innerHTML);
    } else {
      this.closest(".product__content").querySelector(
        '[name="quantity"]'
      ).value = parseInt(this.input_quantity.innerHTML);
    }

    document.querySelector("sticky-add").dispatchEvent(new Event("reload"));
  }
}

customElements.define("variant-pack", variantPack);
